import { Link } from "react-router-dom";

export default function RelatedSinglePost({post}) {
    const { id, image, title, tags, createAt } = post || {};
    let tagsView
    if(tags) tagsView = tags.map((tag , index)=>(
        index === 0 ? <span key={tag}>#{tag}</span> : 
        <span key={tag}>, #{tag}</span>))
    return (

        <div className="card">
            <Link to={`/post/${id}`}>
                <img src={image} className="card-image" alt="" />
            </Link>
            <div className="p-4">
                <Link to={`/post/${id}`} className="text-lg post-title lws-RelatedPostTitle">
                    {title}
                </Link>
                <div className="mb-0 tags">
                {tagsView}
                </div>
                <p>{createAt}</p>
            </div>
        </div>

    )
};